import React, { Component } from "react";

import InputBox from "../../../../../../components/input-box/input-box";
import PhoneBox from "../../../../../../components/phone-box/phone-box";
import { ForeignersHealthContactContainer } from "./contact-form-item-style";

import { withGeneral } from "../../../../../../context/mixin/with-general";
import { ValueFormHealth } from "../../../../../../constants/health";

import HocelotServices from "../../../../../../services/HocelotServices";
import { isValidEmail, isValidMobile } from "../../../../../../utils/validation";
import { ContactDataDto, DefaultContactDataDto } from "./contact-form-item-dto";
import {
  ContactData,
  ForeignersHealthContactProps,
  ForeignersHealthContactState,
} from "./contact-form-item-types";

class ForeignersHealthContact extends Component<
  ForeignersHealthContactProps,
  ForeignersHealthContactState
> {
  constructor(props: ForeignersHealthContactProps) {
    super(props);
    this.state = {
      contactDto: DefaultContactDataDto(),
      previousData: DefaultContactDataDto(),
    };
  }

  componentWillReceiveProps(nextProps: ForeignersHealthContactProps) {
    let { validate } = this.props;
    const sameUserProps =
      nextProps.useTakerData === this.props.useTakerData &&
      nextProps.onEditInsured === this.props.onEditInsured;

    if (nextProps.useTakerData && !nextProps.onCleanForm) {
      if (!this.state.contactDto.sameAsTaker) {
        let newContactData = this.state.contactDto;
        newContactData.sameAsTaker = !newContactData.sameAsTaker;
        this.storePreviousData();
        this.completeDataFromTaker();
        this.setState({ contactDto: newContactData });
      }
    } else if (!nextProps.useTakerData && !nextProps.onCleanForm) {
      let newContactData = this.state.contactDto;
      newContactData.sameAsTaker = false;
      this.setState({ contactDto: newContactData });
      if (
        nextProps.useTakerData !== undefined &&
        this.state.contactDto.sameAsTaker !== nextProps.useTakerData &&
        nextProps.onEditInsured &&
        !sameUserProps
      ) {
        this.completeInsuredData(nextProps.onEditInsured);
      }
    }
    if (nextProps.validate.validateRequest) {
      validate.validateRequest = false;
      validate.isValidated = this.validateForm();
    } else if (nextProps.onCleanForm) {
      this.cleanForm();
    }
    if (
      nextProps.onEditInsured !== undefined &&
      nextProps.onEditInsured !== -1 &&
      !nextProps.useTakerData &&
      !sameUserProps
    ) {
      this.completeInsuredData(nextProps.onEditInsured);
    }
    if (nextProps.isPersonalCheckChanging && !nextProps.useTakerData && !nextProps.onCleanForm) {
      this.getPreviousData();
    }
  }

  getPreviousData() {
    let { previousData, contactDto } = this.state;

    contactDto.comunicationLanguage = previousData.comunicationLanguage;
    contactDto.emailInput = previousData.emailInput;
    contactDto.landlinePhone = previousData.landlinePhone;
    contactDto.mobilePhone = previousData.mobilePhone;
    contactDto.sameAsTaker = false;

    previousData = DefaultContactDataDto();
    this.setState({ previousData, contactDto });
  }

  completeDataFromTaker() {
    const { taker, insured } = this.props;
    if (taker && Object.keys(taker).length > 0) {
      taker.sameAsTaker = true;
      this.setContactData(taker, insured === true);
    }
  }

  setContactData(newData: ContactData, disabled: boolean) {
    const { contactDto } = this.state;
    contactDto.emailInput = this.getValueFormHealthContact(newData.email, disabled);
    contactDto.landlinePhone = this.getValueFormHealthContact(newData.landlinePhone, disabled);
    contactDto.mobilePhone = this.getValueFormHealthContact(newData.mobilePhone, disabled);
    contactDto.sameAsTaker = newData.sameAsTaker;

    this.setState({ contactDto });
  }

  getValueFormHealthContact(
    value: string | ValueFormHealth | undefined,
    disabled: boolean
  ): ValueFormHealth {
    if (!value || typeof value === "string") {
      return {
        value: value ? value : "",
        errorCode: "",
        disabled: disabled,
      };
    } else {
      return {
        value: value.value,
        errorCode: "",
        disabled: disabled,
      };
    }
  }

  componentDidMount() {
    if (
      this.props.taker !== undefined &&
      this.props.taker.mobilePhone !== undefined &&
      !this.props.insured
    ) {
      this.completeFormTakerData();
    } else if (
      this.props.taker !== undefined &&
      this.props.taker.email !== undefined &&
      !this.props.insured
    ) {
      let { contactDto } = this.state;

      contactDto.emailInput.value = this.props.taker.email;

      this.setState({ contactDto });
    }
    if (this.props.insured) {
      this.completeInsuredData(this.props.insuredIndex);
    }
  }

  storePreviousData() {
    const { contactDto } = this.state;
    const previousData: ContactDataDto = JSON.parse(JSON.stringify(contactDto));

    previousData.comunicationLanguage.errorCode = "";
    previousData.emailInput.errorCode = "";
    previousData.landlinePhone.errorCode = "";
    previousData.mobilePhone.errorCode = "";

    this.setState({ previousData });
  }

  completeInsuredData(index: number) {
    let { contactDto } = this.state;
    const { insureds } = this.props;

    if (insureds && insureds[index] !== undefined) {
      contactDto.emailInput.value =
        insureds[index].email !== undefined ? insureds[index].email : "";
      contactDto.landlinePhone.value =
        insureds[index].landlinePhone !== undefined ? insureds[index].landlinePhone : "";
      contactDto.mobilePhone.value =
        insureds[index].mobilePhone !== undefined ? insureds[index].mobilePhone : "";

      contactDto.emailInput.disabled = insureds[index].sameAsTaker;
      contactDto.landlinePhone.disabled = insureds[index].sameAsTaker;
      contactDto.mobilePhone.disabled = insureds[index].sameAsTaker;

      contactDto.emailInput.errorCode = "";
      contactDto.landlinePhone.errorCode = "";
      contactDto.mobilePhone.errorCode = "";

      contactDto.emailInput.disabled = contactDto.sameAsTaker;
      contactDto.landlinePhone.disabled = contactDto.sameAsTaker;
      contactDto.mobilePhone.disabled = contactDto.sameAsTaker;

      this.setState({ contactDto });
    }
  }

  completeFormTakerData() {
    let { contactDto } = this.state;
    const { taker } = this.props;

    if (taker) {
      contactDto.emailInput.value = taker.email;
      contactDto.landlinePhone.value = taker.landlinePhone;
      contactDto.mobilePhone.value = taker.mobilePhone;
    }
    this.setState({ contactDto });
  }

  handleFormChange(value: string, form: string): void {
    let { contactDto } = this.state;
    this.props.onAnyChange();

    if (form === "CORREO") {
      contactDto.emailInput.value = value;
      if (contactDto.emailInput.errorCode) {
        if (contactDto.emailInput.value.length === 0) {
          contactDto.emailInput.errorCode = "";
        } else if (isValidEmail(contactDto.emailInput.value)) {
          contactDto.emailInput.errorCode = "";
        }
      }
    }
    this.setState({ contactDto });
  }

  async validateEmail(value: string) {
    let { contactDto } = this.state;
    if (!this.props.insured) {
      try {
        const result = await HocelotServices.verifyEmail({
          data: { email: value.trim() },
          setLoading: () => {},
        });
        contactDto.emailInput.errorCode = result.isVerified ? "" : "invalid-email";
      } catch (error) {
        contactDto.emailInput.errorCode =
          error && error.status === 422 ? "invalid-email" : "hocelot-verify-error";
      }
      this.setState({ contactDto });
    } else {
      const result = isValidEmail(value);
      if (!result) {
        contactDto.emailInput.errorCode = "invalid-email";
        this.setState({ contactDto });
      }
    }
  }

  handlePhoneValueChange(value: string, type: string) {
    let { contactDto } = this.state;
    this.props.onAnyChange();
    if (type === "FIJO") {
      contactDto.landlinePhone.value = value;
    } else {
      if (contactDto.mobilePhone.value.replace("+34 ", "").length === 0) {
        contactDto.mobilePhone.errorCode = "";
      }
      contactDto.mobilePhone.value = value;
    }
    this.setState({ contactDto });
  }

  validateForm(): boolean {
    let { contactDto } = this.state;
    let noErrors = true;

    //Validación mail
    if (contactDto.emailInput.value.length > 0 && contactDto.emailInput.errorCode !== "") {
      noErrors = false;
    } else if (contactDto.emailInput.value.length === 0) {
      contactDto.emailInput.errorCode = "required";
      noErrors = false;
    } else {
      contactDto.emailInput.errorCode = "";
    }

    //Validación teléfono movil
    const mobileFields = contactDto.mobilePhone.value.split(" ");
    const mobilePrefix = contactDto.mobilePhone.value.split(" ")[0];
    if (mobileFields.length < 2 || !mobilePrefix || !mobileFields[1]) {
      contactDto.mobilePhone.errorCode = "required";
      noErrors = false;
    } else if (mobilePrefix === "+34" && !isValidMobile(contactDto.mobilePhone.value)) {
      contactDto.mobilePhone.errorCode = "invalid-phone-number";
      noErrors = false;
    } else {
      const { countries } = this.props;
      const isValidPrefix = countries.find(
        (country) => country.prefix === mobilePrefix.replace("+", "")
      );
      if (!isValidPrefix) {
        contactDto.mobilePhone.errorCode = "invalid-prefix";
        noErrors = false;
      }
    }

    if (noErrors) {
      contactDto.mobilePhone.errorCode = "";
      this.props.onValidated({
        mobilePhone: contactDto.mobilePhone.value,
        landlinePhone: contactDto.landlinePhone.value,
        email: contactDto.emailInput.value,
        sameAsTaker: contactDto.sameAsTaker,
      });
    }

    this.setState({ contactDto });
    return noErrors;
  }

  cleanForm() {
    this.setState({ contactDto: DefaultContactDataDto() });
  }

  render() {
    const { contactDto } = this.state;
    const { isReadOnly } = this.props;

    return (
      <ForeignersHealthContactContainer>
        <div className="content-wrapper bottomMargin20" ref={""}>
          <div className="personal-data-wrapper" id="data-contact">
            <div className="data-title topMargin20">
              <h5>DATOS CONTACTO</h5>
            </div>
            <div className="colSin-100">
              <div className="colSin-50 rightPadding20 topMargin20 bottomMargin20">
                <div className="inputBox">
                  <PhoneBox
                    errorCode={contactDto.mobilePhone.errorCode}
                    onChange={(value: string) => this.handlePhoneValueChange(value, "MOVIL")}
                    labelText=""
                    required={true}
                    initialValue={contactDto.mobilePhone.value}
                    disabled={contactDto.mobilePhone.disabled || isReadOnly}
                  />
                  <label>teléfono móvil</label>
                </div>
              </div>
              <div className="colSin-50 rightPadding20 topMargin20 bottomMargin20">
                <div className="inputBox">
                  <InputBox
                    errorCode={contactDto.landlinePhone.errorCode}
                    onChange={(value: string) => this.handlePhoneValueChange(value, "FIJO")}
                    placeholder="TELÉFONO FIJO"
                    type={"number"}
                    value={contactDto.landlinePhone.value}
                    maxLength={12}
                    disabled={contactDto.landlinePhone.disabled || isReadOnly}
                  />
                </div>
              </div>

              <div className="colSin-100 rightPadding20 bottomMargin20">
                <div className="inputBox">
                  <InputBox
                    errorCode={contactDto.emailInput.errorCode}
                    onChange={(value: string) => this.handleFormChange(value, "CORREO")}
                    onBlur={(value: string) => this.validateEmail(value)}
                    placeholder="CORREO ELECTRÓNICO"
                    required={true}
                    type={"email"}
                    value={contactDto.emailInput.value}
                    disabled={contactDto.emailInput.disabled || isReadOnly}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ForeignersHealthContactContainer>
    );
  }
}
export default withGeneral(ForeignersHealthContact);
